export const pluralization = {
  'pl-PL': (n: number, numberOfChoices: number) => {
    const input = Math.abs(n)
    const returnCandidate = () => {
      if (input === 0) return 0
      if (input === 1) return 1
      const mod10 = input % 10
      const mod100 = input % 100
      if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return 2
      return 3
    }
    return Math.min(returnCandidate(), numberOfChoices - 1)
  },
}
